<template>
    
</template>

<script>
    export default {
        name: "uploadResume"
    }
</script>

<style scoped>

</style>